module.exports = __webpack_public_path__ + "static/jgl-bw-53b95052f0b02fae2ecf4150eb9655c2.jpg";